<template>
  <div>
    <b-button
      variant="outline-success"
      class="mt-2"
      v-b-modal.modal-prevent-closing-group-adder
      >Створити групу</b-button
    >
    <b-modal
      centered
      id="modal-prevent-closing-group-adder"
      ref="modal"
      title="Створення групи"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Назва"
          label-for="name-input"
          invalid-feedback="Введіть назву групи!"
          :state="modalState"
        >
          <b-form-input type="text" v-model="name"></b-form-input>
        </b-form-group>
        <b-form-group
          label="День тижня"
          invalid-feedback="Вкажіть дні тижня!"
          :state="modalState"
        >
          <b-form-select
            style="width: 200px; height: 160px"
            size="lg"
            v-model="day"
            :options="options"
            multiple
            :select-size="4"
          ></b-form-select>
        </b-form-group>
        <b-form-group
          label="ЧасІ"
          invalid-feedback="Вкажіть час заняття!"
          :state="modalState"
        >
          <b-form-input type="time" v-model="daytime"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Вартість візиту"
          label-for="visitcost-input"
          invalid-feedback="Вкажіть вартість!"
          :state="modalState"
        >
          <b-form-input type="number" v-model="visit_cost"></b-form-input>
        </b-form-group>
        <b-form-group
          label="Тренер"
          label-for="trainer-input"
          invalid-feedback="Оберіть тренера!"
          :state="modalState"
        >
          <b-form-input
            class="mb-1"
            type="text"
            v-model="search"
          ></b-form-input>
          <b-form-select
            id="trainer-input"
            v-model="trainer"
            :options="trainerOptions"
            class="mb-2"
          ></b-form-select>
        </b-form-group>
        <b-form-textarea
          v-model="description"
          placeholder="Опис"
        ></b-form-textarea>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
  name: "groupCreator",
  data: function () {
    return {
      modalState: null,
      name: null,
      day: [],
      daytime: null,
      visit_cost: null,
      trainer: null,
      description: null,
      options: [
        { value: "1", text: "Понеділок" },
        { value: "2", text: "Вівторок" },
        { value: "3", text: "Середа" },
        { value: "4", text: "Четвер" },
        { value: "5", text: "П'ятниця" },
        { value: "6", text: "Субота" },
        { value: "7", text: "Неділя" },
      ],
      trainerOptions: [],
      search: "",
    };
  },
  computed: {
    ...mapState(["trainers"]),
  },
  watch: {
    search: function (newValue) {
      this.trainerOptions = [];
      if (newValue !== "") {
        console.log(newValue);
        let trainer_list = this.trainers.filter((trainer) => {
          return trainer.surname.startsWith(newValue);
        });
        trainer_list.forEach((trainer) => {
          this.trainerOptions.push({
            value: trainer.id,
            text: trainer.surname + " " + trainer.name,
          });
        });
      } else {
        this.trainers.forEach((trainer) => {
          this.trainerOptions.push({
            value: trainer.id,
            text: trainer.surname + " " + trainer.name,
          });
        });
      }
    },
  },
  methods: {
    resetModal() {
      this.name = null;
      this.day = [];
      this.daytime = null;
      this.visit_cost = null;
      this.trainer = null;
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      let payload = {
        name: this.name,
        day: this.day,
        daytime: this.daytime,
        visit_cost: this.visit_cost,
        trainer: this.trainer,
        club_id: this.$cookie.get("club_id"),
        description: this.description,
      };
      await axios
        .post(`${process.env.VUE_APP_API}/staticschedule/add`, payload, {
          headers: {
            Authorization: `Bearer ${this.$cookie.get("access_token")}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.$emit("success");
          this.$emit("refresh");
        })
        .catch((error) => {
          if (error.response) {
            this.$emit("req-error");
          }
        });
      this.$nextTick(() => {
        this.$bvModal.hide("modal-prevent-closing-group-adder");
      });
    },
  },
};
</script>

<style scoped></style>
